<div class="repeat-section-add">
  <cap-button
    class="add"
    styleClass="primary"
    icon="mynaui-plus"
    [disabled]="addDisabled()"
    [label]="'button.add' | translate"
    (onClick)="add()" />
</div>

<div class="repeat-section">
  @for (field of field.fieldGroup; track field; let index = $index) {
    <div class="repeat-section-item">
      <formly-field [field]="field" />
      <div class="repeat-section-action">
        @if (!formControl.at(index)?.value?.is_edit) {
          <cap-button
            styleClass="default primary round btn-sm icon-only"
            icon="mynaui-pencil"
            [disabled]="addDisabled()"
            (onClick)="edit(index)" />

          <cap-button
            styleClass="default primary round btn-sm icon-only"
            icon="mynaui-trash"
            [disabled]="addDisabled()"
            (onClick)="remove(index)" />
        } @else {
          <cap-button styleClass="default secondary round btn-sm icon-only" icon="mynaui-x" (onClick)="cancel(index)" />

          <cap-button
            styleClass="default secondary round btn-sm icon-only"
            icon="mynaui-check"
            (onClick)="save(index)" />
        }
      </div>
    </div>
  } @empty {
    <div class="repeat-empty">
      <p>{{ props.emptyText }}</p>
    </div>
  }
</div>
